export default () => [
  'AF',
  'EG',
  'AX',
  'AL',
  'DZ',
  'AS',
  'VI',
  'AD',
  'AO',
  'AI',
  'AQ',
  'AG',
  'GQ',
  'AR',
  'AM',
  'AW',
  'AC',
  'AZ',
  'ET',
  'AU',
  'BS',
  'BH',
  'BD',
  'BB',
  'BY',
  'BE',
  'BZ',
  'BJ',
  'BM',
  'BT',
  'BO',
  'BA',
  'BW',
  'BV',
  'BR',
  'VG',
  'IO',
  'BN',
  'BG',
  'BF',
  'BI',
  'EA',
  'CL',
  'CN',
  'CP',
  'CK',
  'CR',
  'CI',
  'DK',
  'DE',
  'DG',
  'DM',
  'DO',
  'DJ',
  'EC',
  'SV',
  'ER',
  'EE',
  'FK',
  'FO',
  'FJ',
  'FI',
  'FR',
  'GF',
  'PF',
  'GA',
  'GM',
  'GE',
  'GH',
  'GI',
  'GD',
  'GR',
  'GL',
  'GB',
  'GP',
  'GU',
  'GT',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'HM',
  'HN',
  'HK',
  'IN',
  'ID',
  'IM',
  'IQ',
  'IR',
  'IE',
  'IS',
  'IL',
  'IT',
  'JM',
  'JP',
  'YE',
  'JE',
  'JO',
  'KY',
  'KH',
  'CM',
  'CA',
  'IC',
  'CV',
  'KZ',
  'QA',
  'KE',
  'KG',
  'KI',
  'CC',
  'CO',
  'KM',
  'CD',
  'KP',
  'KR',
  'HR',
  'CU',
  'KW',
  'LA',
  'LS',
  'LV',
  'LB',
  'LR',
  'LY',
  'LI',
  'LT',
  'LU',
  'MO',
  'MG',
  'MW',
  'MY',
  'MV',
  'ML',
  'MT',
  'MA',
  'MH',
  'MQ',
  'MR',
  'MU',
  'YT',
  'MK',
  'MX',
  'FM',
  'MD',
  'MC',
  'MN',
  'ME',
  'MS',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NC',
  'NZ',
  'NI',
  'NL',
  'AN',
  'NE',
  'NG',
  'NU',
  'MP',
  'NF',
  'NO',
  'OM',
  'XO',
  'AT',
  'TL',
  'PK',
  'PS',
  'PW',
  'PA',
  'PG',
  'PY',
  'PE',
  'PH',
  'PN',
  'PL',
  'PT',
  'PR',
  'TW',
  'CG',
  'RE',
  'RW',
  'RO',
  'RU',
  'BL',
  'MF',
  'SB',
  'ZM',
  'WS',
  'SM',
  'ST',
  'SA',
  'SE',
  'CH',
  'SN',
  'RS',
  'SC',
  'SL',
  'ZW',
  'SG',
  'SK',
  'SI',
  'SO',
  'ES',
  'LK',
  'SH',
  'KN',
  'LC',
  'PM',
  'VC',
  'ZA',
  'SD',
  'GS',
  'SR',
  'SJ',
  'SZ',
  'SY',
  'TJ',
  'TZ',
  'TH',
  'TG',
  'TK',
  'TO',
  'TT',
  'TA',
  'TD',
  'CZ',
  'TN',
  'TR',
  'TM',
  'TC',
  'TV',
  'UG',
  'UA',
  'HU',
  'UY',
  'UZ',
  'VU',
  'VA',
  'VE',
  'AE',
  'US',
  'GB',
  'VN',
  'WF',
  'CX',
  'EH',
  'CF',
  'CY',
];
